import {
  Stack,
  Typography,
  IconButton,
  Button,
  FormHelperText,
} from '@mui/material';
import { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import PropTypes from 'prop-types';
import { useFieldArray, useFormContext } from 'react-hook-form';

export default function TestCases({ methods, parentFieldName }) {
  // variables
  const fieldName = `${parentFieldName}.testCases`;

  // hooks
  const {
    fields: codingTestCasesFields,
    append: appendCodingTestCase,
    remove: removeCodingTestCase,
  } = useFieldArray({
    control: methods.control,
    name: fieldName,
  });

  const {
    formState: { errors },
  } = useFormContext();

  return (
    <Stack spacing="12px">
      {codingTestCasesFields.map(
        (codingTestCaseField, codingTestCaseFieldIndex) => {
          const inputFieldName = `${fieldName}.${codingTestCaseFieldIndex}.input`;
          const outputFieldName = `${fieldName}.${codingTestCaseFieldIndex}.output`;

          return (
            <Stack direction="row" spacing="20px" width="100%">
              <Stack width="50%" spacing="10px">
                <Typography variant="subheading2" fontSize={16}>
                  Sample Input {codingTestCaseFieldIndex + 1}
                </Typography>
                <RHFTextField
                  name={inputFieldName}
                  placeholder="Sample Input"
                  fullWidth
                />
              </Stack>
              <Stack width="50%" spacing="6px">
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing="6px"
                >
                  <Typography variant="subheading2" fontSize={16}>
                    Sample Output {codingTestCaseFieldIndex + 1}
                  </Typography>
                  <IconButton
                    sx={{
                      width: '20px',
                      height: '20px',
                      padding: '2px',
                    }}
                    onClick={() =>
                      removeCodingTestCase(codingTestCaseFieldIndex)
                    }
                  >
                    <Iconify
                      icon="tabler:trash"
                      color={theme => theme.palette.background.primaryRed1}
                    />
                  </IconButton>
                </Stack>
                <RHFTextField
                  name={outputFieldName}
                  placeholder="Sample Output"
                  fullWidth
                />
              </Stack>
            </Stack>
          );
        },
      )}
      <Stack>
        <Button
          variant="outlined"
          startIcon={<Iconify icon="tabler:plus" />}
          onClick={() => appendCodingTestCase({ input: '', output: '' })}
          sx={{
            width: '200px',
          }}
        >
          Sample input/output
        </Button>
        {errors?.codingAssessments?.map((assessment, index) =>
          assessment?.questions?.map((question, questionIndex) => (
            <FormHelperText
              key={index}
              error={!!question?.testCases}
              sx={{ px: 2 }}
            >
              {question?.testCases?.message}
            </FormHelperText>
          )),
        )}
      </Stack>
    </Stack>
  );
}

TestCases.propTypes = {
  methods: PropTypes.object.isRequired,
  parentFieldName: PropTypes.string.isRequired,
};
